import React from 'react';

import Content from '../Content/Content';
import Markup from '../../base/Markup/Markup';

import { parseSpacing } from '../../utils/parseSpacing';

/**
 * Renders a <MarkupContent /> component
 * @param {Object} props
 * @param {string} props.content
 * @param {"left"|"right"|"center"|"justify"} props.textAlign
 */
const MarkupContent = ({ content, textAlign }) => (
  <Content sx={{ textAlign: parseSpacing(textAlign) }}>
    {content && <Markup content={content} />}
  </Content>
);

export default MarkupContent;
